import { render } from "./servelist.vue?vue&type=template&id=40141de0&scoped=true"
import script from "./servelist.vue?vue&type=script&lang=js"
export * from "./servelist.vue?vue&type=script&lang=js"

import "./servelist.vue?vue&type=style&index=0&id=40141de0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40141de0"]])

export default __exports__